/* eslint-disable import/no-named-as-default */
import { ApolloClient, ApolloLink, createHttpLink } from '@apollo/client';
import { defaultDataIdFromObject, InMemoryCache } from '@apollo/client/cache';
import { onError } from '@apollo/client/link/error';
import * as Sentry from '@sentry/browser';

import { authUser } from '~/lib/client';

const cache = new InMemoryCache({
  cacheRedirects: {
    Query: {
      company: (_, args, { getCacheKey }) => {
        const cacheObject = { __typename: 'Company', id: args.id };
        return getCacheKey(cacheObject);
      },
      audience: (_, args, { getCacheKey }) => {
        const cacheObject = { __typename: 'Audience', id: args.id };
        return getCacheKey(cacheObject);
      },
    },
  },
  dataIdFromObject: (object) => {
    switch (object.__typename) {
      case 'Attribute': {
        // attributeType is added by the backend to ensure
        // person attributes and company attributes don't overwrite each other!
        const { category, value, subCategory, attributeType } = object;
        return `${object.__typename}:${attributeType}:${category}-${subCategory}-${value}`;
      }
      default:
        return defaultDataIdFromObject(object);
    }
  },
  possibleTypes: {
    Collection: ['CompanySegmentCollection', 'PersonSegmentCollection'],
    Node: [
      'Company',
      'CompanySegment',
      'CompanySegmentCollection',
      'Person',
      'PersonSegment',
      'PersonSegmentCollection',
    ],
    Segment: ['CompanySegment', 'PersonSegment'],
  },
});

const client = new ApolloClient({
  cache,
  link: ApolloLink.from([
    onError(({ graphQLErrors, networkError }) => {
      if (graphQLErrors) {
        graphQLErrors.forEach((error) => {
          const { message, locations, path } = error;
          /* eslint-disable-next-line no-console */
          console.error(
            `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
          );

          Sentry.captureException(error);
        });
      }
      if (networkError) {
        if (
          networkError.statusCode === 401 &&
          networkError.result?.error?.type === 'auth'
        ) {
          authUser();
        }
        /* eslint-disable-next-line no-console */
        console.error(`[Network error]: ${networkError}`);
      }
    }),
    createHttpLink({
      uri: (query) => {
        return `/graphql?${query.operationName}`;
      },
    }),
  ]),
});

export default client;
